import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, notification, Drawer, Button, Space, Modal } from "antd";
import { faFilter, faEdit, faEllipsis } from '@fortawesome/free-solid-svg-icons';
import Pagination from "@mui/material/Pagination";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TobNavBar from "../DashBaord/Top_navbar";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { ASSETS_BASE_URL } from "../../config/constants";
import { fetchIpAddress } from "../../controllers/API";
import { DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import LoadingEffect from "../../components/Loading/LoadingEffect";
import { EditOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';
// import ReactToPdf from "react-to-pdf";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  LikeOutlined,
  DislikeOutlined,
} from "@ant-design/icons";

import SkeltonList from "../../components/SkeltonEffect/list";
import { registerationlist, deleteRegisterationList } from "../../controllers/submissions/submissionController";
import { getPage, statusMessage } from "../../controllers/common";

function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {

  const [popUpOpen, setPopUpOpen] = useState(false);
  const togglePopUp = () => {
    setPopUpOpen(!popUpOpen);
  };

  const [isFilterShow, setFilterShow] = useState(false);
  const handleFiterDrawer = () => {
    setFilterShow(!isFilterShow);
  }

  /************************************************************************************* */
  const [isLoading, setIsLoading] = useState(true);
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [exportLoadingText, setExportLoadingText] = useState(false);
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const [deleteId, setDeleteId] = useState("");
  const [error, setError] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "",
    search: "",
  }); //End

  const [showRequest, setShowRequest] = useState("");

  const handleEdit = async (item = {}) => {
    navigate("/registration/addeditdata", { state: item });
  };
  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          ...(showRequest ? { status: showRequest } : null),
        },
        ...(filter ? { filter: filter } : null),
        select: {},
        sort: { status: 1, _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await registerationlist(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count));
          setIsLoading(false);
        } else {
          setListData([]);
          setTotalPages(getPage(1))
          setIsLoading(false);
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function is use to delete partner
   *********************************************************/
  const handleDelete = async () => {
    try {
      if (deleteId) {
        const options = { id: deleteId };
        const res = await deleteRegisterationList(options);
        if (res.status === true) {
          notification.open({
            message: "Deleted!",
            description: "Data Deleted Successfully.",
            placement: "topRight",
            duration: 2,
            icon: <DeleteOutlined style={{ color: "green" }} />,
          });
        } else {
          notification.open({
            message: "Oops!!",
            description: "Please try again.",
            placement: "topRight",
            duration: 2,
            icon: <DeleteOutlined style={{ color: "red" }} />,
          });
        }
        setConfirmDelete(false);
      } else {
        notification.open({
          message: "Error",
          description: "Data Not Found! Try Again.",
          placement: "topRight",
          duration: 2,
          icon: <DeleteOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      notification.open({
        message: "Error",
        description: "An error occurred while deleting. Please try again.",
        placement: "topRight",
        duration: 2,
        icon: <DeleteOutlined style={{ color: "red" }} />,
      });
    }
    getList();
  };

  /*********************************************************
  *  This function is ued for handle filter input chnage
  *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      inputRef1.current.value = '';
      inputRef2.current.value = '';
    } catch (error) {

    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      setFilter((pre) => ({
        ...pre,
        'filter_by': form.get('filter_by') || '',
        'search': form.get('search') || '',
      }))
      handleFiterDrawer();
      setSkip(0);
    } catch (error) {
      console.log(error);
    }
  }


  const [isConfirmDelModalOpen, setConfirmDelete] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [modalData, setModalData] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  // const [mySheetData, setMySheetData] = useState([]);

  // const [dataSheet, setDataSheet] = useState([]);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setModalData("");
  };
  const handleViewItem = (item) => {
    setModalData(item);
    setIsModalOpen(true);
  }

  const handleExportPopup = () => {
    setIsExportModalOpen(true);
  }
  const handleExportCancel = () => {
    setIsExportModalOpen(false);
  };

  const handleConfirmDelPopup = (id) => {
    setDeleteId(id);
    setConfirmDelete(true);
  }
  const handleConfirmDeleteCancel = () => {
    setConfirmDelete(false);
  };


  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleInputChange = (e) => {
    if (e.target.name === 'startdate') {
      setStartDate(e.target.value);
    } else if (e.target.name === 'enddate') {
      setEndDate(e.target.value);
    }
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  const handleExportBWDates = async () => {
    setIsExportLoading(true);
    setExportLoadingText('Loading Data....');
    try {
      // const isValidate = validateExportDates();
      let isValidate = true;
      if (isValidate) {
        const exportOptions = {
          type: "",
          condition: {
            status: 'A',
            // createdAt: {
            //   ...(startDate ? { $gt: startDate } : {}),
            //   ...(endDate ? { $lt: endDate } : {}),
            //   // $gt: startDate,
            //   // $lt: endDate,
            // }
            ...(startDate || endDate ? {
              createdAt: {
                ...(startDate ? { $gt: startDate } : {}),
                ...(endDate ? { $lt: endDate } : {}),
              },
            } : {}),
          },
        };
        // console.log('endDate', endDate);
        // console.log('endDate',endDate);
        const exportDatas = await registerationlist(exportOptions);
        console.log('API res time bat', exportDatas);
        if (exportDatas.status === true) {
          if (exportDatas?.result.length > 0) {
            prepareSheetData(exportDatas?.result);
          } else {
            alert('No data found');
          }
        } else {
          setIsExportLoading(false);
          console.log('api error');
        }
      } else {
        setIsExportLoading(false);
        console.log('not validated');
      }
    } catch (error) {
      setIsExportLoading(false);
      console.log("error", error);
    } finally {
      setIsExportLoading(false);
    }
  }

  const validateExportDates = () => {
    if (!startDate || startDate === "undefined" || startDate === null) {
      setError((preError) => ({
        ...preError,
        startdate: "Start date is required",
      }));
      return false;
    }
    if (!endDate || endDate === "undefined" || endDate === null) {
      setError((preError) => ({
        ...preError,
        enddate: "End date is required",
      }));
      return false;
    }
    if (new Date(startDate) > new Date(endDate)) {
      return setError(prev => ({ ...prev, endDate: "End date must be after the start date" }));
    }
    return true;
  };

  /*********************** Get data for export to excel *********************** */
  const getExcelExportData = async () => {
    try {
      setIsExportLoading(true);
      setExportLoadingText('Loading Data....');
      const exportOptions = {
        type: "",
        condition: {
          status: 'A',
        },
      };
      const exportData = await registerationlist(exportOptions);
      console.log('API res', exportData);
      if (exportData.status === true) {
        if (exportData?.result.length > 0) {
          prepareSheetData(exportData?.result);
        } else {
          alert('No data found');
        }
      } else {
        setIsExportLoading(false);
        console.log('api error');
      }
    } catch (error) {
      console.log('error', error);
    }
  }; //End

  const prepareSheetData = (data) => {
    console.log('dataCount -', data.length);
    setExportLoadingText('Preparing Your Data....');
    const mySheet = data.map((items) => {

      const applicationDetails = items?.previous_application_details
        ?.map(detail => `${detail.child_name} (${detail.program_class}, ${detail.applied_year})`)
        ?.join("; ");
      return {
        "First name": items?.first_name || '',
        "Last name": items?.last_name || '',
        "Gender": items?.gender || '',
        "D.O.B": items?.dob || '',
        "Nationality": items?.nationality || '',
        "Applied program": items?.applied_program || '',
        "Admission campus": items?.admission_campus || '', //new 
        "Admission year": items?.admission_year || '',  //new 
        "Passport number": items?.passport_number || '',
        "Place of issue": items?.place_of_issue || '',
        "Passport exp date": items?.passport_exp_date || '',
        "Other Passports": items?.other_passports || '',
        "Visa type": items?.visa_type || '',
        "Visa issue date": items?.visa_issue_date || '',
        "Visa place of issue": items?.visa_place_of_issue || '',
        "Visa exp date": items?.visa_exp_date || '',
        "Passport type": items?.passport_type || '',
        "Previous school name": items?.previous_school_name || '',
        "Current grade": items?.current_grade || '',
        "Reason of leaving": items?.reason_of_leaving || '',
        "Home address": items?.home_address || '',
        "Phone": items?.phone || '',
        "Pincode": items?.pin_code || '',
        "state": items?.state || '',
        "city": items?.city || '',
        "Previously applied": items?.previously_applied || '',
        "Previous application details": applicationDetails,
        "Admission granted || ''": items?.admission_granted || '',
        "Admission taken": items?.admission_taken || '',
        "Reason not taken": items?.reason_not_taken || '',
        "Sibling applied to kc": items?.sibling_applied_to_kc || '',
        // "sibling_residence_phone": items?.sibling_residence_phone || '',
        // "sibling_pin_code": items?.sibling_pin_code || '',
        // "sibling_state": items?.sibling_state || '',
        // "sibling_city": items?.sibling_city || '',
        "Sibling name": items?.sibling_name || '',
        "Sibling grade": items?.sibling_grade || '',
        "Is applying for more": items?.is_applying_for_more || '',
        "Father name": items?.father_name || '',
        "Father occupation": items?.Father_occupation || '',
        "father work address": items?.Father_work_address || '',
        "Father company name": items?.father_company_name || '',  //new
        "Father city": items?.father_city || '',
        "father pin code": items?.father_pin_code || '',
        "father state": items?.father_state || '',
        "father country": items?.father_country || '',
        "father country code": items?.father_country_code || '',
        "father phone": items?.father_phone || '',
        "father email": items?.father_email || '',
        "mother name": items?.mother_name || '',
        "mother occupation": items?.mother_occupation || '',
        "mother work address": items?.mother_work_address || '',
        "mother company name": items?.mother_company_name || '',  //new
        "mother pincode": items?.mother_pin_code || '',
        "mother city": items?.mother_city || '',
        "mother state": items?.mother_state || '',
        "mother country": items?.mother_country || '',
        "mother country code": items?.mother_country_code || '',
        "mother phone": items?.mother_phone || '',
        "mother email": items?.mother_email || '',
        "Emergency contacts1": items?.emergency_contacts1 || '',
        "Emergency contacts2": items?.emergency_contacts2 || '',
        "Second language choice": items?.second_language_choice || '',
        "Learn source": items?.learn_source || '',
        "Questionnaire 1": items?.questionnaire1 ? items.questionnaire1.match(/[^/]+$/)?.[0] : "N/A",
        "Questionnaire 2": items?.questionnaire2 ? items.questionnaire2.match(/[^/]+$/)?.[0] : "N/A"
      }
    });
    // setDataSheet(mySheet);
    downloadExcel(mySheet);
    setIsExportLoading(false);
  }


  const downloadExcel = (dataSheet = []) => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Convert data for each sheet
    const worksheet = XLSX.utils.json_to_sheet(dataSheet);

    // Append sheets to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Registrations");

    // Trigger download
    XLSX.writeFile(workbook, "KC_High_Registrations.xlsx");
  };


  const dropdownMenu = (items) => {
    return (
      <>
        <Menu>
          <Menu.Item key="01" onClick={() => handleViewItem(items)}>
            <EyeOutlined />
            <span className="show_span_edit">View</span>
          </Menu.Item>
          <Menu.Item key="02" onClick={() => handleEdit(items)}>
          <EditOutlined />
            <span className="show_span_edit">Edit</span>
          </Menu.Item>
          <Menu.Item key="03" 
          // onClick={() => handleDelete(items?._id)}
          onClick={() => handleConfirmDelPopup(items?._id)}
          >
            <DeleteOutlined />
            <span className="show_span_edit">Delete</span>
          </Menu.Item>
        </Menu>
      </>
    );
  };

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
    });
    document.title = "KC High Admin || Registrations List";
  }, [currentPage, showRequest, filter]);



  const ref = React.createRef();
  const generatePdf = async () => {
    const modalContent = document.getElementById('modal-content');
    if (!modalContent) return;

    // Use html2canvas to capture the modal content
    const canvas = await html2canvas(modalContent, { scale: 2 });
    const imgData = canvas.toDataURL('image/png');

    // Generate PDF using jsPDF
    const pdf = new jsPDF();
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${modalData?.first_name || 'registration'} ${modalData?.last_name || 'details'}.pdf`.trim());
  };

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Registrations List"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div onClick={() => handleEdit()}>
                    <button type="button" class="btn btn-dark">
                      <FontAwesomeIcon icon="fa-regular fa-plus Promotions_faPlus_Squares" />
                      <span className="request_new_categories">Add New</span>
                    </button>
                  </div>
                  <div onClick={() => handleExportPopup()}>
                    <button type="button" class="btn btn-dark">
                      <FontAwesomeIcon icon="fa-regular fa-plus Promotions_faPlus_Squares" />
                      <span className="request_new_categories">Export to Excel</span>
                    </button>
                  </div>
                  <div className="fa_filter_rating_review filter_img_and_add_btn_main px-2">
                    <div className="inventory_filter_div" onClick={handleFiterDrawer}>
                      <Link
                        to={false}
                        className="filter_btn_invontry_rating_review"
                      >
                        <FontAwesomeIcon icon={faFilter} /> Filters
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </Box>
            <VendorList>
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body all_card_body_padding">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead className="all_table_form">
                            <tr>
                              <th>S.No.</th>
                              <th>Name</th>
                              <th>Contact Info</th>
                              <th>DOB</th>
                              <th>Father' Name</th>
                              <th>Questionnaire</th>
                              <th>Date</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index}>
                                    <td>{(currentPage - 1) * 10 + index + 1}</td>
                                    <td className="admin_user_list_date">{items?.first_name}{" "}{items?.last_name}</td>
                                    <td className="admin_user_list_date">{items?.phone}</td>
                                    <td className="admin_user_list_date">{items?.dob}</td>
                                    <td className="admin_user_list_date">{items?.father_name}</td>
                                    {/* <td className="admin_user_list_date">{items?.questionnaire1.match(/[^/]+$/)[0]}<br></br>{items?.questionnaire1.match(/[^/]+$/)[0]}</td> */}
                                    <td className="admin_user_list_date">
                                      {items?.questionnaire1 ? items.questionnaire1.match(/[^/]+$/)?.[0] : "N/A"}
                                      <br />
                                      {items?.questionnaire1 ? items.questionnaire1.match(/[^/]+$/)?.[0] : "N/A"}
                                    </td>
                                    <td className="admin_user_list_date">{moment(`${items.createdAt}`).format(
                                      "DD/MM/YYYY hh:mm A"
                                    )}</td>
                                    <td>
                                      <Dropdown
                                        overlay={() => dropdownMenu(items)}
                                        placement="bottomLeft"
                                        arrow
                                      >
                                        <FontAwesomeIcon icon={faEllipsis} />
                                      </Dropdown>
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={10} col={8} /> : <tr>
                              <td colspan="8" className="img-center" >No data found !</td>
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
          {/***************************  Confirm delete  *****************************/}
          <Modal open={isConfirmDelModalOpen} onCancel={handleConfirmDeleteCancel} 
          onOk={() => handleDelete()}
          okText="Yes, Delete"
          okButtonProps={{ style: { backgroundColor: '#a23333' } }}
          >
            <div className="row mt-3">
              <h6>Do you confirm to delete this registartion ?</h6>
            </div>
          </Modal>

          {/************************************* Export to excel popup popup************************************************/}
          <Modal open={isExportModalOpen} onCancel={handleExportCancel}
            footer={null}
            width={800}
          >
            <div className="row text-center">
              <div className="col-12">
                <h5>Export to Excel</h5>
                <hr></hr>
              </div>
            </div>
            <div className="row text-center mt-3">
              <div className="form-group col-lg-6 col-md-6 col-6">
                <span>Select start date</span>
                <input
                  type="date"
                  name="startdate"
                  onChange={handleInputChange}
                  className="form-control store_input_field"
                />
                {error.startdate ? (
                  <p style={{ color: "red" }}>
                    {error.startdate}
                  </p>
                ) : (
                  ""
                )}
              </div>
              <div className="form-group col-lg-6 col-md-6 col-6">
                <span>Select end date</span>
                <input
                  type="date"
                  name="enddate"
                  onChange={handleInputChange}
                  className="form-control store_input_field"
                />
                {error.enddate ? (
                  <p style={{ color: "red" }}>
                    {error.enddate}
                  </p>
                ) : (
                  ""
                )}
              </div>
              <div className="col-12 mt-3">
                <button className="btn btn-primary" onClick={handleExportBWDates}>Export</button>
              </div>
            </div>
          </Modal>

          {/************************************* View registration details popup************************************************/}
          <Modal open={isModalOpen} onCancel={handleCancel}
            footer={null}
            width={1000}
            className="viewregmodal"
          >
            <div id="modal-content" className="row">
              <div className="col-12 mt-3">
                <h5 className="text-center">Registration details</h5>
                <div className="row">
                  <span>Child/Student details</span>
                  <hr></hr>
                  <div className="col-4">
                    <p><strong>First Name</strong> : {modalData?.first_name}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>Last Name</strong> : {modalData?.last_name}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>Gender</strong> : {modalData?.gender}</p>
                  </div>
                  <div className="col-3">
                    <p><strong>Nationality</strong> : {modalData?.nationality}</p>
                  </div>
                  <div className="col-3">
                    <p><strong>D.O.B</strong> : {modalData?.dob}</p>
                  </div>
                  <div className="col-6">
                  <p><strong>Gaurdian email</strong> : {modalData?.gaurdian_email}</p>
                  </div>
                </div>
                <div className="row">
                  <hr></hr>
                  <div className="col-6">
                    <p><strong>Campus</strong> : {modalData?.admission_campus}</p>
                  </div>
                  <div className="col-6">
                    <p><strong>Session Year</strong> : {modalData?.admission_year}</p>
                  </div>
                  <div className="col-12">
                    <p><strong>Program for which admission is sought</strong> : {modalData?.applied_program}</p>
                  </div>
                </div>
                <div className="row">
                  <span>Home details</span>
                  <hr></hr>
                  <div className="col-8">
                    <p><strong>Address</strong> : {modalData?.home_address}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>Phone no.</strong> : {modalData?.phone}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>Pincode</strong> : {modalData?.pin_code}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>State</strong> : {modalData?.state}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>City</strong> : {modalData?.city}</p>
                  </div>
                </div>
                <div className="row">
                  <span>Passport details</span>
                  <hr></hr>
                  <div className="col-4">
                    <p><strong>Child Passport No.</strong> : {modalData?.passport_number}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>Passport issue place</strong> : {modalData?.place_of_issue}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>Passport expiray date</strong> : {modalData?.passport_exp_date}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>Other Passports ?</strong> : {modalData?.other_passports}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>Type of Visa of child</strong> : {modalData?.visa_type}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>Visa issue date</strong> : {modalData?.visa_issue_date}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>Visa issue place</strong> : {modalData?.visa_place_of_issue}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>Visa expiry date</strong> : {modalData?.visa_exp_date}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>Type of passport</strong> : {modalData?.passport_type}</p>
                  </div>
                </div>
                <div className="row">
                  <span>Previous School details</span>
                  <hr></hr>
                  <div className="col-8">
                    <p><strong>School name</strong> : {modalData?.previous_school_name}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>Current grade</strong> : {modalData?.current_grade}</p>
                  </div>
                  <div className="col-12">
                    <p><strong>Reason of leaving</strong> : {modalData?.reason_of_leaving}</p>
                  </div>
                </div>
                <div className="row">
                  <span>Other details</span>
                  <hr></hr>
                  <div className="col-6">
                    <p><strong>Have you applied to KC earlier for your child/children?</strong> : {modalData?.previously_applied}</p>
                  </div>
                  <div className="col-6">
                    <p><strong>Were you granted admission?</strong> : {modalData?.admission_granted}</p>
                  </div>
                  <div className="col-6">
                    <p><strong>If yes, did you take up the admission in KC?</strong> : {modalData?.admission_taken}</p>
                  </div>
                  <div className="col-6">
                    <p><strong>If not, please mention why.</strong> : {modalData?.reason_not_taken}</p>
                  </div>
                </div>
                <div className="row">
                  <span>Sibling details</span>
                  <hr></hr>
                  <div className="col-12">
                    <p><strong>Do you have a sibling who is currently studying or has studied at KC ?</strong> : {modalData?.admission_taken}</p>
                  </div>
                  <div className="col-3">
                    <p><strong>Sibling name</strong> : {modalData?.sibling_residence_phone}</p>
                  </div>
                  <div className="col-3">
                    <p><strong>Sibling grade</strong> : {modalData?.sibling_grade}</p>
                  </div>
                  <div className="col-6">
                    <p><strong>Are you applying for more than one child ?</strong> : {modalData?.is_applying_for_more}</p>
                  </div>
                </div>
                <div className="row">
                  <span>Father/Gaurdian details</span>
                  <hr></hr>
                  <div className="col-4">
                    <p><strong>Name</strong> : {modalData?.father_name}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>Occupation</strong> : {modalData?.Father_occupation}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>Phone</strong> : {modalData?.father_country_code}{" "}{modalData?.father_phone}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>Email</strong> : {modalData?.father_email}</p>
                  </div>
                  <div className="col-8">
                    <p><strong>Work Address</strong> : {modalData?.Father_work_address}</p>
                  </div>
                  <div className="col-3">
                    <p><strong>Company name</strong> : {modalData?.father_company_name}</p>
                  </div>
                  <div className="col-3">
                    <p><strong>Pincode</strong> : {modalData?.father_pin_code}</p>
                  </div>
                  <div className="col-3">
                    <p><strong>Country</strong> : {modalData?.father_country}</p>
                  </div>
                  <div className="col-3">
                    <p><strong>State</strong> : {modalData?.father_state}</p>
                  </div>
                  <div className="col-3">
                    <p><strong>city</strong> : {modalData?.father_city}</p>
                  </div>
                </div>
                <div className="row">
                  <span>Mother/Gaurdian details</span>
                  <hr></hr>
                  <div className="col-4">
                    <p><strong>Name</strong> : {modalData?.mother_name}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>Occupation</strong> : {modalData?.mother_occupation}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>Phone</strong> : {modalData?.mother_country_code}{" "}{modalData?.mother_phone}</p>
                  </div>
                  <div className="col-4">
                    <p><strong>Email</strong> : {modalData?.mother_email}</p>
                  </div>
                  <div className="col-8">
                    <p><strong>Work Address</strong> : {modalData?.mother_work_address}</p>
                  </div>
                  <div className="col-3">
                    <p><strong>Company name</strong> : {modalData?.father_company_name}</p>
                  </div>
                  <div className="col-3">
                    <p><strong>Pincode</strong> : {modalData?.mother_pin_code}</p>
                  </div>
                  <div className="col-3">
                    <p><strong>Country</strong> : {modalData?.mother_country}</p>
                  </div>
                  <div className="col-3">
                    <p><strong>State</strong> : {modalData?.mother_state}</p>
                  </div>
                  <div className="col-3">
                    <p><strong>city</strong> : {modalData?.mother_city}</p>
                  </div>
                </div>
                <div className="row">
                  <span>Emergency Contacts</span>
                  <hr></hr>
                  <div className="col-6">
                    <p><strong>Phone 1</strong> : {modalData?.emergency_contacts1}</p>
                  </div>
                  <div className="col-6">
                    <p><strong>Phone 2</strong> : {modalData?.emergency_contacts2}</p>
                  </div>
                </div>
                {/* <div className="row">
                  <hr></hr>
                  <div className="col-6">
                    <p><strong>Campus</strong> : {modalData?.admission_campus}</p>
                  </div>
                  <div className="col-6">
                    <p><strong>Session Year</strong> : {modalData?.admission_year}</p>
                  </div>
                  <div className="col-12">
                    <p><strong>Program for which admission is sought</strong> : {modalData?.applied_program}</p>
                  </div>
                </div> */}
                <div className="row">
                  <hr></hr>
                  <div className="col-6">
                    <p><strong>Choice of Second Language:</strong> : {modalData?.second_language_choice}</p>
                  </div>
                  <div className="col-6">
                    <p><strong>How did you learn about KC High?:</strong> : {modalData?.learn_source}</p>
                  </div>
                </div>
                <p><strong>Received On</strong> : {moment(`${modalData.createdAt}`).format("DD/MM/YYYY hh:mm A")}</p>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-12 d-flex" style={{ justifyContent: "space-around" }}>
                { modalData?.questionnaire1 ? (
                  <Link to={ASSETS_BASE_URL + modalData?.questionnaire1} target="_blank"><button className="btn-danger btn nventory_save_button">First Questionnaire</button></Link>
                ) : null }
                { modalData?.questionnaire2 ? (
                  <Link to={ASSETS_BASE_URL + modalData?.questionnaire2} target="_blank"><button className="btn-danger btn nventory_save_button">Second Questionnaire</button></Link>
                ) : null }
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-12 d-flex" style={{ justifyContent: "center" }}>
                <Button key="download" onClick={generatePdf}>
                  Download Details as PDF
                </Button>
              </div>
            </div>
          </Modal>

          <LoadingEffect isLoading={isExportLoading} />
        </div>
      </div>
      <Drawer
        title="Registrations Filter"
        placement={`right`}
        width={500}
        onClose={handleFiterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFiterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset} style={{ backgroundColor: 'red', color: 'white' }}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" id="filter_by" ref={inputRef1}>
                  <option value=''>Select search field</option>
                  <option value='first_name' selected={filter?.filter_by === 'first_name' ? true : false}>First name</option>
                  <option value='last_name' selected={filter?.filter_by === 'last_name' ? true : false}>Last name</option>
                  <option value='gaurdian_email' selected={filter?.filter_by === 'gaurdian_email' ? true : false}>Gaurdian Email</option>
                  <option value='father_name' selected={filter?.filter_by === 'father_name' ? true : false}>Father name</option>
                  <option value='father_email' selected={filter?.filter_by === 'father_email' ? true : false}>Father email</option>
                  <option value='mother_name' selected={filter?.filter_by === 'mother_name' ? true : false}>Mother name</option>
                  <option value='mother_email' selected={filter?.filter_by === 'mother_email' ? true : false}>Mother email</option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"
                  ref={inputRef2}
                />
              </div>
              <br />
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"
                  style={{ backgroundColor: "black", color: "white" }}
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
    </>
  );
}
